<template>
	<div class="result" :class="{ empty: !value }">
		<div class="result__icon">
			<Icon :name="icon" />
		</div>
		<h2 class="result__text">{{ firstLine }}<br />{{ secondLine }}</h2>
	</div>
</template>

<script>
import Icon from '@/components/Icon'

export default {
	name: 'RecycleResult',
	props: {
		name: String,
		value: Number,
		icon: String,
		becomes: String,
		measure: String
	},
	computed: {
		firstLine() {
			return this.value > 0 ? this.becomes : `0 ${this.measure}`
		},
		secondLine() {
			return this.value > 0 ? `(${this.value} ${this.measure})` : ''
		}
	},
	components: {
		Icon
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins';

.result {
	text-align: center;

	&.empty {
		opacity: 0.65;
	}

	&__icon {
		@include circle(10.5rem, white);
		align-items: center;
		display: inline-flex;
		justify-content: center;
		margin-bottom: 1.5rem;

		svg {
			width: 6rem;
			height: 6rem;
			color: $green-44;
		}
	}

	&__text {
		color: $green-29;
		margin: 0;
		white-space: pre;
	}
}
</style>
